import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import type { IconType } from "react-icons";
import { useHomeLabel } from "./useHomeLabel";

interface Props {
  labelKey: string; sublabel: string; icon: IconType; primary?: boolean; badge?: number; onClick: () => void;
}

export const HeroActionCard = ({ labelKey, sublabel, icon, primary, badge, onClick }: Props) => {
  const homeLabel = useHomeLabel();
  return (
    <Flex
      as="button"
      onClick={onClick}
      direction="column"
      justify="space-between"
      textAlign="left"
      minH="104px"
      p="4"
      rounded="2xl"
      position="relative"
      border="1px solid"
      borderColor={primary ? "transparent" : "smBorder"}
      // smPrimarySolid stays a mid/deep teal in both modes (teal.500 / teal.600), so white
      // text + the whiteAlpha overlays keep contrast — unlike smPrimary, which lightens to
      // teal.200 in dark mode and would wash out white-on-teal.
      bg={primary ? "smPrimarySolid" : "smBackground"}
      _hover={{ borderColor: primary ? "transparent" : "smPrimary", shadow: "sm" }}
    >
      <Box>
        <Flex w="34px" h="34px" rounded="lg" align="center" justify="center" mb="3" bg={primary ? "whiteAlpha.300" : "smPrimarySofter"}>
          <Icon as={icon} color={primary ? "white" : "smPrimary"} boxSize="4" />
        </Flex>
        <Text fontWeight="bold" color={primary ? "white" : "smText"}>{homeLabel(labelKey)}</Text>
        <Text fontSize="sm" color={primary ? "whiteAlpha.900" : "smMuted"}>{sublabel}</Text>
      </Box>
      {badge !== undefined && badge > 0 && (
        <Box position="absolute" top="3" right="3" minW="18px" h="18px" px="1.5" rounded="full" bg="smAlertBadge" color="white" fontSize="0.66rem" fontWeight="bold" display="flex" alignItems="center" justifyContent="center" border="2px solid" borderColor={primary ? "white" : "smBackground"}>{badge}</Box>
      )}
    </Flex>
  );
};
